import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { TRANSLATIONS_SV } from "./dictionaries/sv";
import { TRANSLATIONS_EN } from "./dictionaries/en";
import { TRANSLATIONS_DA } from "./dictionaries/da";
import { TRANSLATIONS_DE } from "./dictionaries/de";
import { TRANSLATIONS_ES } from "./dictionaries/es";
import { TRANSLATIONS_FR } from "./dictionaries/fr";
import { TRANSLATIONS_NO } from "./dictionaries/no";
import { TRANSLATIONS_PT } from "./dictionaries/pt";
import { TRANSLATIONS_UK } from "./dictionaries/uk";
import {Languages} from "../constants/languages";

// If we change fallback language to example Swedish we need to change the fallback flag in the language picker in the LanguagesDropdown.tsx line: 70

export const i18n = i18next
  .use(LanguageDetector)
  .use(initReactI18next)

i18n.init({
  fallbackLng: Languages.English,
  resources: {
    en: {
      translation: TRANSLATIONS_EN
    },
    sv: {
      translation: TRANSLATIONS_SV
    },
    da: {
      translation: TRANSLATIONS_DA
    },
    de: {
      translation: TRANSLATIONS_DE
    },
    es: {
      translation: TRANSLATIONS_ES
    },
    fr: {
      translation: TRANSLATIONS_FR
    },
    no: {
      translation: TRANSLATIONS_NO
    },
    pt: {
      translation: TRANSLATIONS_PT
    },
    uk: {
      translation: TRANSLATIONS_UK
    },
  }
});

export default i18n